import * as React from 'react';
import { connect } from 'react-redux';
import { select } from '@rematch/select';
import { Trans } from 'react-i18next';

import { AppLayout } from '../../layouts/AppLayout';
import { ThemeConsumer } from '../../atoms/theme';
import { Text } from '../../atoms/text';
import { NotificationsList } from '../../widgets/notifications-list';
import { NotificationsNav } from '../../widgets/notifications-list';
import { Card, Row, Col } from 'ui';

class Renderer extends React.Component {
  render() {
    return (
      <AppLayout
        center={
          <ThemeConsumer>
            {() => (
              <Card
                shrinked
                style={{ fontSize: 12, fontWeight: 'bold', lineHeight: '14px' }}
                title={
                  <Row item={{ style: { fontSize: 12 }}}>
                    <Col item={{ flex: '1' }}>
                      <Text color="#90A4AE" style={{ textTransform: 'uppercase' }}>
                        <Trans>Your Notifications</Trans>
                      </Text>
                    </Col>
                    <Col>
                      <NotificationsNav />
                    </Col>
                  </Row>
                  
                }
              >
                <NotificationsList limit={20} viewer={this.props.viewer} />
              </Card>
            )}
          </ThemeConsumer>
        }
      />
    );
  }
}

const mapState = (state) => ({
  viewer: select.session.user(state),
});

export const PageNotifications = connect(mapState)(Renderer);
